import { createSelector } from 'reselect'
import { RootState } from 'store'

export const crumbSelector = createSelector(
  (state: RootState) => state.crumbs,
  state => state
)
export const crumbsSelector = createSelector(crumbSelector, state => state.value)
